export default __webpack_public_path__ + "static/media/12.1a2f42b8.JPG";